<template lang="pug">
div.pad
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required|cpf", v-slot="{ errors }", :name="nomeAba + '/CPF'")
        app-label(label="CPF:")
        el-input.input(
          name='CPF',
          v-model="pessoaFisica.cpf",
          v-mask="'###.###.###-##'",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Nome'")
        app-label(label="Nome:")
        el-input.input(
          name='Nome',
          maxlength="300",
          v-model="pessoaFisica.nome",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'pessoaFisica','nome')"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="requiredRg.rules", v-slot="{ errors }", :name="nomeAba + '/RG'")
        app-label(label="RG:", :required="requiredRg.label")
        el-input.input(
          name='RG',
          maxlength="30",
          v-model="pessoaFisica.rg",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'pessoaFisica','rg')"
        )
        span.help.erro {{ errors[0] }}

  el-row.labelDiv(v-if="isProcessoFisico" :gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(v-slot="{ errors }", :name="nomeAba + '/Tipo de documento'")
        app-label(label="Tipo de documento:", :required="false")
        el-select.input(
          class="select",
          name='Tipo de documento'
          v-model="pessoaFisica.tipoDocumento",
          value-key="codigo"
          no-match-text="Nenhum tipo de documento encontrado",
          placeholder="Selecione",
          clearable,
          filterable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="(item, index) in tipoDocumentos",
            :key="index",
            :label="item",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(v-if="pessoaFisica.tipoDocumento == 'OUTROS'" :span="8")
      validation-provider(rules='required', v-slot="{ errors }", :name="nomeAba + '/OutrosTipoDocumento'")
        app-label(label="Outros:", :required="true")
        el-input.input(
          name='Outros',
          maxlength="30",
          v-model="pessoaFisica.outrosTipoDocumento",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'pessoaFisica','outrosTipoDocumento')"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(:rules="requiredRg.rules", v-slot="{ errors }", :name="nomeAba + '/Órgão Expedidor'",  mode="lazy")
        app-label(label="Órgão expedidor:", :required="requiredRg.label")
        el-select.input(
          name='Órgão expedidor',
          class="select",
          no-match-text="Nenhum orgão encontrado",
          placeholder="Selecione",
          v-model="pessoaFisica.orgaoExpedidor.nome",
          value-key="id",
          filterable,
          clearable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="orgaoExpedidor in orgaosExpedidores",
            :key="orgaoExpedidor.id",
            :label="orgaoExpedidor.nome",
            :value="orgaoExpedidor.nome"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="requiredRg.rules", v-slot="{ errors }", :name="nomeAba + '/UF do RG'",  mode="lazy")
        app-label(label="UF do RG:", :required="requiredRg.label")
        el-select.input(
          name='UF do RG'
          class="select",
          no-match-text="Nenhuma UF encontrada",
          placeholder="Selecione",
          v-model="pessoaFisica.orgaoExpedidor.estado"
          clearable,
          filterable,
          :disabled="!pessoaFisica.orgaoExpedidor.nome",
          :class="{'erro' : errors.length}"
          @change="setOrgaoCodigo"
        )
          el-option(
            v-for="estado in estadosBr",
            :key="estado.codigo",
            :label="estado.nome",
            :value="estado.codigo"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8" v-if="!isBeneficiarioTeq")
      app-input-telefone(
        :telefones="pessoa.telefones",
        :nomeAba="nomeAba",
        :requiredTelefones="!isProcessoFisico"
        :observer="observer"
      )
    el-col.inputDiv(:span="8" v-if="!isLiberacao && !isProcessoFisico")
      validation-provider(:rules="required.rules" v-slot="{ errors }", :name="nomeAba + '/Nome da Mãe'" mode="lazy")
        app-label(label="Nome da Mãe:" :required="required.label")
        el-input.input(
          type="text"
          maxlength="300"
          name='nomeDaMae'
          v-model="pessoaFisica.nomeDaMae"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Nacionalidade'",  mode="lazy")
        app-label(label="Nacionalidade:")
        el-select.input(
          name='Nacionalidade'
          class="select",
          no-match-text="Nenhuma nacionalidade encontrada",
          placeholder="Selecione",
          v-model="pessoaFisica.nacionalidade"
          value-key="id"
          clearable,
          filterable,
          @change='changeNacionalidade',
          :class="{'erro' : errors.length}"
        )
          el-option.selectNacionalidade(
            v-for="item in gentilico",
            :key="item.id",
            :label="item.gentilico +' - '+ item.nomePais",
            :value="item.sigla",
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="ufAndMunicipioRequired()", v-slot="{ errors }", :name="nomeAba + '/UF de Naturalidade'",  mode="lazy")
        app-label(label="UF de naturalidade:", :required="!isProcessoFisico && isBrasileiro && required.label")
        el-select.input(
          class="select",
          no-match-text="Nenhuma UF encontrada",
          placeholder="Selecione",
          v-model="pessoaFisica.ufNaturalidade",
          clearable,
          @change='setMunicipioUf',
          filterable,
          :disabled="!isBrasileiro",
          name="UF de naturalidade",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in estadosBr",
            :key="item.codigo",
            :label="item.nome",
            :value="item.codigo"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="ufAndMunicipioRequired()", v-slot="{ errors }", :name="nomeAba + '/Município de Naturalidade'",  mode="lazy")
        app-label(label="Município de naturalidade:", :required="!isProcessoFisico && isBrasileiro && required.label")
        el-select.input(
          class="select",
          name='Município de Naturalidade'
          no-match-text="Nenhum município encontrado",
          placeholder="Selecione",
          v-model="pessoaFisica.naturalidade",
          filterable,
          :disabled="!pessoaFisica.ufNaturalidade",
          :class="{'erro' : errors.length}"
          value-key="id"
        )
          el-option(
            v-for="item in municipios",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
  el-row(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(:rules="!isProcessoFisico ? required.rules: ''", v-slot="{ errors }", :name="nomeAba + '/Data de nascimento'")
        app-label(label="Data de nascimento:", :required="required.label && !isProcessoFisico")
        el-date-picker.input.full-width(
          type="date",
          name='Data de nascimento'
          v-model="pessoaFisica.dataNascimento",
          placeholder="Selecione",
          format="dd/MM/yyyy",
          v-mask="'##/##/#####'",
          :picker-options="pickerOptions",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="required.rules", v-slot="{ errors }", :name="nomeAba + '/Estado civil'")
        app-label(label="Estado civil:", :required="required.label")
        el-select.input(
          class="select",
          name='Estado civil'
          v-model="pessoaFisica.estadoCivil",
          value-key="codigo"
          no-match-text="Nenhum estado civil encontrado",
          placeholder="Selecione",
          clearable,
          filterable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in estadosCivil",
            :key="item.codigo",
            :label="item.nome",
            :value="item.codigo"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8" v-if="!isBeneficiarioTeq && !isProcessoFisico")
      validation-provider(rules="required|email", v-slot="{ errors }", :name="nomeAba + '/E-mail'")
        app-label(label="E-mail:")
        el-input.input(
          name="E-mail",
          v-model="pessoa.email",
          maxlength="100"
          label='email',
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="8" v-if="isBeneficiarioTeq")
      validation-provider(rules="" v-slot="{ errors }", :name="nomeAba + '/Apelido'" mode="lazy")
        app-label(label="Apelido:" :required="false")
        el-input.input(
          type="text"
          maxlength="300"
          name='apelido'
          v-model="pessoaFisica.apelido"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row(:gutter="30")
    el-col(:span="8" v-if="isLiberacao")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Profissão'")
        app-label(label="Profissão:")
        el-select.input(
          class="select",
          name='Profissão'
          v-model="pessoaFisica.profissao",
          value-key="codigo"
          no-match-text="Nenhuma profissão encontrada",
          placeholder="Selecione",
          clearable,
          filterable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in profissoes",
            :key="item.codigo",
            :label="item.nome",
            :value="item.codigo"
          )
        span.help.erro {{ errors[0] }}
    app-dados-conjuge.conjuge(
      v-if="hasConjuge"
      :pessoa='conjuge.pessoaFisica'
      :isViuvo="pessoaFisica.estadoCivil === 'VIUVO'"
      :nomeAba="nomeAba || 'Interessado'"
      :isProcessoFisico="isProcessoFisico"
      :estadoCivil="this.pessoa.pessoaFisica.estadoCivil"
    )

</template>
<script>
import { mapActions } from 'vuex'

import AppLabel from '@/components/AppLabel'
import estadosBr from '@/constants/estados'
import gentilico from '@/constants/gentilico'
import AppDadosConjuge from './AppDadosConjuge'
import AppInputTelefone from '@/components/AppInputTelefone'
const { estadosCivil, tipoDocumentos } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasCentral').default
const { profissoes } = require('@/utils/ma/regrasCentral').default

export default {
  components: {
    AppLabel,
    AppDadosConjuge,
    AppInputTelefone
  },

  props: {
    pessoa: {
      type: Object,
      required: true
    },
    conjuge: {
      required: false
    },
    nomeAba: {
      type: String,
      required: true
    },
    observer: {
      required: true
    },
    isLiberacao: {
      type: Boolean,
      required: false,
      default: false
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    },
    // Para setar estrutura diferente de dados do beneficiario que vem do off pro online e vice-versa
    isBeneficiarioTeq: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      oldEstadoCod: '',
      orgaosExpedidores: [],
      estadosBr,
      gentilico,
      estadosCivil,
      tipoDocumentos,
      profissoes,
      municipios: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      isMaranhao: process.env.ESTADO === 'ma'
    }
  },

  mounted () {
    if (this.isLiberacao && !this.isProcessoFisico) {
      this.profissoes = profissoes()
    }
    this.setOrgaosExpeditores()
    if (this.isProcessoFisico) {
      this.estadosBr.forEach(element => {
        element.nome = element.nome.toUpperCase()
      })

      this.estadosCivil.forEach(element => {
        element.nome = element.nome.toUpperCase()
      })

      this.gentilico.forEach(element => {
        element.gentilico = element.gentilico.toUpperCase()
        element.nomePais = element.nomePais.toUpperCase()
      })
    }
  },

  computed: {
    isBrasileiro () {
      return (
        this.pessoaFisica.nacionalidade &&
        this.pessoaFisica.nacionalidade === 'BR'
      )
    },

    pessoaFisica () {
      return this.pessoa.pessoaFisica
    },

    hasConjuge () {
      if (this.isProcessoFisico) {
        return this.conjuge &&
        this.pessoaFisica.estadoCivil &&
        (this.pessoaFisica.estadoCivil === 'CASADO' ||
        this.pessoaFisica.estadoCivil === 'UNIAO_ESTAVEL')
      }
      return (
        this.conjuge &&
        this.pessoaFisica.estadoCivil &&
        (this.pessoaFisica.estadoCivil === 'CASADO' ||
          this.pessoaFisica.estadoCivil === 'UNIAO_ESTAVEL' ||
          this.pessoaFisica.estadoCivil === 'UNIAO_HOMOAFETIVA' ||
          this.pessoaFisica.estadoCivil === 'VIUVO')
      )
    },
    required () {
      if (this.isBeneficiarioTeq) {
        return { rules: '', label: false }
      }
      return { rules: 'required', label: true }
    },

    requiredRg () {
      if (this.isBeneficiarioTeq || this.isMaranhao) {
        return { rules: '', label: false }
      }
      return { rules: 'required', label: true }
    }
  },

  methods: {
    ...mapActions({
      getOrgaosExpedidores: 'orgaosExpedidores/getItems',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),

    async setOrgaosExpeditores () {
      this.orgaosExpedidores = await this.getOrgaosExpedidores()

      if (this.isProcessoFisico) {
        this.orgaosExpedidores.forEach(element => {
          element.nome = element.nome.toUpperCase()
        })
      }
      if (this.isBeneficiarioTeq && this.pessoaFisica.orgaoExpedidor.codigo) {
        this.findOrgaoExpedidorNameByCodigo()
        await this.setMunicipioUf(this.pessoaFisica.ufNaturalidade)
        this.pessoaFisica.naturalidade = this.pessoaFisica.naturalidade
      }
    },

    async changeEstado () {
      this.pessoa.municipio = null
      this.municipios = await this.getMunicipiosByUf(this.pessoa.ufNaturalidade)
    },

    async setMunicipioUf (sigla) {
      this.pessoaFisica.naturalidade = null
      this.municipios = await this.getMunicipiosByUf(sigla)
    },

    changeNacionalidade () {
      if (!this.isBrasileiro) {
        this.pessoaFisica.ufNaturalidade = null
        this.pessoaFisica.naturalidade = null
      }
    },

    ufAndMunicipioRequired () {
      return !this.isBeneficiarioTeq &&
        !this.isProcessoFisico &&
        this.pessoaFisica.nacionalidade &&
        this.pessoaFisica.nacionalidade === 'BR'
        ? 'required'
        : ''
    },

    findOrgaoExpedidorNameByCodigo () {
      this.pessoaFisica.orgaoExpedidor.nome = this.orgaosExpedidores.find(
        orgao => orgao.codigo === this.pessoaFisica.orgaoExpedidor.codigo
      ).nome
    },

    setOrgaoCodigo () {
      if (this.isBeneficiarioTeq || this.isProcessoFisico) {
        this.pessoaFisica.orgaoExpedidor.codigo = this.orgaosExpedidores.find(
          orgao => orgao.nome === this.pessoaFisica.orgaoExpedidor.nome
        ).codigo
      }
    },
    toUppercase (valor, primeiro, segundo) {
      if (this.isProcessoFisico) {
        this[primeiro][segundo] = valor.toUpperCase()
      }
    }
  },

  async activated () {
    if (this.pessoaFisica.ufNaturalidade) {
      this.municipios = await this.getMunicipiosByUf(
        this.pessoaFisica.ufNaturalidade
      )
    }
  },

  watch: {
    'pessoaFisica.ufNaturalidade': {
      async handler (val, oldval) {
        if (val && val !== oldval) {
          this.municipios = await this.getMunicipiosByUf(val)
          if (this.isProcessoFisico) {
            this.municipios.forEach(element => {
              element.nome = element.nome.toUpperCase()
            })
          }
        }
      }
    },
    'pessoaFisica.estadoCivil' (newVal) {
      if (!['CASADO', 'UNIAO_ESTAVEL'].includes(newVal)) {
        this.conjuge.pessoaFisica.cpf = ''
        this.conjuge.pessoaFisica.nome = ''
        this.conjuge.pessoaFisica.tipoDocumento = ''
        this.conjuge.pessoaFisica.outrosTipoDocumento = ''
        this.conjuge.pessoaFisica.rg = ''
        this.conjuge.pessoaFisica.orgaoExpedidor.nome = ''
        this.conjuge.pessoaFisica.orgaoExpedidor.estado = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.conjuge {
  margin-left: 15px;
}
.select {
  width: 100%;
}

.full-width {
  width: 100%;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 100%;
  }

  .selectNacionalidade {
    left: 210px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppPessoaFisica.vue